import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const UpdateStatusSlice = createSlice({
    name: "updateStatusRequest",
    initialState,
    reducers: {
        updateStatusRequest(state) {
            state.loading = true;
        },
        updateStatusRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        updateStatusRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        updateStatusStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    updateStatusRequest,
    updateStatusRequestSuccess,
    updateStatusRequestError,
    updateStatusStateReset,
} = UpdateStatusSlice.actions;

export default UpdateStatusSlice.reducer;
